var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"padding":"10%"}},[_c('h2',{staticClass:"text-center"},[_vm._v(" 繳費"+_vm._s(_vm.result)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }